import PartnerForm from "./PartnerForm";
import { AutoPagePaperLayout } from "pages/Layouts/AutoPagePaperLayout";
import { PageBreadcrumbs, PageTitle } from "pages/Layouts/components/PageTitleContainer";

export function PartnerNew() {
  return (
    <AutoPagePaperLayout>
      <PageBreadcrumbs links={[{ label: "Logistics" }, { label: "Partners", path: "/logistics/partners" }]} />
      <PageTitle>Add New Partner</PageTitle>
      <PartnerForm />
    </AutoPagePaperLayout>
  );
}
